import React from "react";

function claimTotal(node) {
  return Object.values(node.coverage || {}).reduce((sum, count) => sum + count, 0);
}

export default function CorrespondencesLink({ node, tradition, type }) {
  if (!tradition || !node) return null;

  const segment = type === "path" ? "paths" : "sephiroth";
  const noun = type === "path" ? "path" : "sephirah";
  // A sephirah has a name; a path has a LETTER name. Reaching for `node.name`
  // on both produced "Sources for undefined" on every path.
  const label = type === "path" ? node.letterName : node.name;
  const total = claimTotal(node);
  const href = `/tree/${tradition.param}/${segment}/${node.slug}/correspondences`;

  // ONE name for this destination across the whole site. It used to be called
  // "Further correspondences" here, "Sources" in the marker panel, "Research"
  // in the page title and "the sourced account" on the button — four names for
  // one kind of page, which is three too many. It is called Sources.
  return (
    <section className="detail-link" data-testid="correspondences-link">
      <h3 className="detail-link__heading">Sources</h3>
      <p className="detail-link__body">
        {total > 0
          ? `Where each of the ${total} correspondence${total === 1 ? "" : "s"} on this ${noun} comes from.`
          : `What is on record for this ${noun}, and what is not.`}
      </p>
      <a
        className="detail-link__button"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="correspondences-link-open"
      >
        {`Sources for ${label}`}
      </a>
    </section>
  );
}
